import { useRouter } from 'next/router';
import React from 'react';
import { Badge } from 'Components/frameworks/badge/Badge';
import { Button } from 'Components/frameworks/button/Button';
import { ICONS } from 'Components/utils/icon/icons';
import { useAppContext } from 'Context/ReactAppContext';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import * as pleUtils from 'Utils/ple-utils';
import { convertUrlToOrigin } from 'Utils/uri/uriUtils';
type CustomerLoginProps = {
  hasLoginButton: boolean;
  hasUser: boolean;
  labels: {
    memberSpace: string;
    memberSpaceTitle: string;
    labelCTA: string;
  };
};
export const CustomerLogin = ({
  hasLoginButton,
  hasUser,
  labels: { memberSpace, memberSpaceTitle, labelCTA },
}: CustomerLoginProps) => {
  const { locale, originalUrl } = useAppContext();
  const { asPath } = useRouter();
  const origin = convertUrlToOrigin(originalUrl);
  const redirectUri = origin + asPath;
  const { trackClickEvent } = useTrackEvent();

  if (!hasLoginButton || hasUser) {
    return null;
  }

  return (
    <div
      data-testid="CustomerLogin"
      className="mb-20 h-full rounded-16 border-1 border-lightGrey bg-white p-20"
    >
      <div className="block items-center justify-between md:flex">
        <div className="mb-20 flex items-start gap-20 md:mb-0">
          <Badge
            className="size-48 border-black bg-black text-white"
            iconName={ICONS.PEOPLE}
            variant="pill"
          />
          <div className="text-start">
            <p className="text-20 font-semibold leading-normal">{memberSpaceTitle}</p>
            <p className="mt-4 text-14 leading-normal">{memberSpace}</p>
          </div>
        </div>
        <div className="flex w-full justify-center md:w-1/3 md:justify-end">
          <Button
            data-testid="prebooking-form-login"
            className="text-center"
            isExternalLink
            onClick={() =>
              trackClickEvent(TRACK_EVENT_NAMES.CLICK_PREBOOKING_FORM_PREREG, {
                detail_click: 'login_to_my_space',
              })
            }
            url={pleUtils.buildSigninUrl({
              locale,
              redirectUri,
              previousUri: redirectUri,
            })}
          >
            {labelCTA}
          </Button>
        </div>
      </div>
    </div>
  );
};
